import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';

@Component({
  selector: 'app-classlist',
  templateUrl: './classlist.component.html',
  styleUrls: ['./classlist.component.css']
})
export class ClasslistComponent {
  @Input() lessons: any;
  @Input() admin: boolean;
  @Input() canViewLessons: boolean;
  // populated by the parent (modules/details) from
  // OfflineSaveService.savedState$; empty/undefined is the same as "nothing saved," so this
  // component stays a no-op presentational component when the feature is off, same as today.
  @Input() savedLessonIds: Set<number> = new Set();
  // True while offline/degraded AND the feature is on — greys out unsaved lessons instead of
  // letting them fail on tap.
  @Input() offlineDegraded = false;
  constructor(private classmanager: ClassmanagementService, private toastr: ToastrService) { }

  getHTMLIDRef(id: string) {
    return `#collapse${id}`;
  }

  // Students open the first lesson they have not completed; admins see no completion state, so none opens.
  isNextLesson(lesson: any): boolean {
    if (this.admin) return false;
    return this.lessons?.find((l: any) => !l.completed) === lesson;
  }

  async movelessondown(e: Event, lessonid:number, lessontitle: string, moduleid:number)
  {
    e.stopPropagation();
    this.toastr.warning('Moving Lesson Down', lessontitle);
    this.lessons=await this.classmanager.movelessondown(lessonid,moduleid).toPromise();
    this.toastr.success('Moved Lesson Down', lessontitle);
  }

  async movelessonup(e: Event, lessonid:number, lessontitle: string, moduleid:number)
  {
    e.stopPropagation();
    this.toastr.warning('Moving Lesson Up', lessontitle);
    this.lessons=await this.classmanager.movelessonup(lessonid,moduleid).toPromise();
    this.toastr.success('Moved Lesson Up', lessontitle);
  }
}
